<style scoped>
    @import url("../../../styles/smartControl/dialogEAC.scss");
</style>

<template>
    <div class="box_dialogEAC">

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">

            <v-progress-circular
                color="black"
                size="64"
                indeterminate
            >
                <span :style="{'font-size':'0.9rem'}">Aguarde</span>
            </v-progress-circular>
        </div>

        <div class="box_t" v-if="!flagLoading && flagMsg">
            <v-icon class="mt-1 mb-1" size="36" color="#1F7AB1">{{ iconMsg }}</v-icon>
            <span class="sub_t">{{ msg }}</span>
        </div>

        <div class="box_t" v-if="!flagLoading && !flagMsg">
            <v-icon class="mt-1 mb-1" size="36" color="#1F7AB1">mdi-pencil-outline</v-icon>
            <span class="main_t">Confirmar atualização</span>
            <span class="sub_t">Todas as alterações serão consideradas</span>
        </div>

        <div class="painelBtn" v-if="!flagLoading && !flagMsg">

            <v-btn class=""
            small
            color="success"
            @click="upAlerts()"
            >
                Atualizar
            </v-btn>

            <v-btn class=""
            small
            color="primary"
            @click="back2edit()"
            >
                Cancelar
            </v-btn>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
//import { randomUUID } from 'node:crypto'; // 05/10/2026

export default {

    props:['liAlert'],

    data() {
        return {
            flagLoading:false,
            msg:'',
            flagMsg:false,
        }
    },

    methods: {

        procAlert() {
            let liLocal = this.liAlert // rcv via props (não mutável)
            let li2send = [] // to return

            let el = {}
            let liAssLocal = []
            let el_ass = {}
            let statusBool2send = null // aux
            let j = 0
            let c=0
            while (c < liLocal.length) {

                liAssLocal = [] // reset
                j=0 // reset
                while (j < liLocal[c]['li'].length) {

                    el_ass = {
                        'device_id':liLocal[c]['li'][j]['device_id'], // (!)
                        //'tit':liLocal[c]['li'][j]['tit_gatilho'], // <-- título do sensor/índice calc.
                        'tit':liLocal[c]['li'][j]['tit'], // <-- título do sensor/índice calc.
                        'target_key':liLocal[c]['li'][j]['target_key'], // (!)
                        //'limiar_sup':23,
                        //'limiar_inf':"",
                        'utc_romp':liLocal[c]['li'][j]['utc_romp'],
                        //'flag_romp':false, // default
                        'flag_romp':liLocal[c]['li'][j]['flag_romp']
                    }

                    if (liLocal[c]['li'][j]['tipo_limiar'] == 'superior') {
                        el_ass['limiar_sup'] = liLocal[c]['li'][j]['limiar']
                        el_ass['limiar_inf'] = ''
                    }
                    else {
                        el_ass['limiar_sup'] = ''
                        el_ass['limiar_inf'] = liLocal[c]['li'][j]['limiar']
                    }

                    liAssLocal.push(el_ass)
                    j++
                }
                
                //console.log("liLocal[c]['status']: ",liLocal[c]['status'])
                if (liLocal[c]['status'] == 'on') { statusBool2send = true }
                else { statusBool2send = false }
                //console.log("statusBool2send: ",statusBool2send)

                //console.log("liLocal[c].t: ",liLocal[c].t)
                //console.log("liLocal[c].categoria: ",liLocal[c].categoria)
                const keyStrLi = (liLocal[c].categoria === 'i') ? 'li_indices_ass' : 'li_sensores_ass'
                const keyStrLiOther = (liLocal[c].categoria === 'i') ? 'li_sensores_ass' : 'li_indices_ass'
                //console.log("keyStrLi: ",keyStrLi)

                // apenas criar id quando ainda nao houver
                const n_random = liLocal[c]['id_alert'] || crypto.randomUUID();

                const utc_created = liLocal[c]['utc_created'] || new Date().toISOString();

                el = {
                    'id_alert':n_random,
                    'utc_created':utc_created,
                    'flag_active':statusBool2send,
                    'tit':liLocal[c]['t'],
                    'freq_hrs':liLocal[c]['freq_hrs'],
                    //'utc_last_romp':'', // após editado (ou novo) reseta a contagem do efeito
                    'utc_last_romp':liLocal[c]['utc_last_romp'],
                    [keyStrLi]:liAssLocal,
                    [keyStrLiOther]:[], // key contrária da selecionada (e sempre vazia)
                }
                li2send.push(el)
                c++
            }
            return li2send
        },
        
        upAlerts() { 
            //console.log('up') 

            this.flagLoading = true // habilitar loading

            // -- formatar lista de alertas para o envio de atualização.
            let li2send = this.procAlert()
            //console.log('li2send:',li2send)

            let emailCliente = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025
            let sistema = this.sistema = this.$store.state.sistemaSC

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = { 
                'cliente': emailCliente,
                'sistema': sistema,
                'li2send': li2send
            }

            let url = self.$store.state.pathAxiosBASE + '/upalertconfig' // concat

            axios.post(url, params, {headers}).then(function (res) {

                //console.log(res.data.result)
                let flagConfirm = res.data.result

                // -- msg de confirmação no front
                if (flagConfirm == 'up-alert-config-ok') { 
                    self.msg = 'Alertas atualizados.' 
                    self.iconMsg = 'mdi-check-decagram' 
                    
                    setTimeout(() => {
                        self.$emit('reloadPagefromDialogAlert',true) // nova chamada (update front)
                    },3000)
                }
                else { self.msg = 'Falha ao tentar atualizados alertas. Tente novamente mais tarde.'; self.iconMsg = 'mdi-alert-decagram' }
                self.flagMsg = true

                self.flagLoading = false // -- encerrar loading

                setTimeout(() => {
                    self.$emit('fromDialogAlert',false) // encerrar dialog
                },3000)
            })
        },

        back2edit() { this.$emit('fromDialogAlert',false) },
    },

    created() {
        //this.$store.commit('srcIPloja') // without param. Initial main GET Req.
    }
}
</script>